import { render, staticRenderFns } from "./LocalizacionIncendio.vue?vue&type=template&id=5e1bcff6"
import script from "./LocalizacionIncendio.vue?vue&type=script&lang=js"
export * from "./LocalizacionIncendio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports